import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../content/css/ContractReviewer.css';
import { contractReviewerActions as actions } from '../../actions';
import AuthService from "../../services/auth.service";
import NavMenu from './NavMenu';
import { TrialBanner } from '../TrialBanner';
import ErrorBoundary from '../ErrorBoundary';
import Topbar from './Topbar';

class Layout extends Component {
    constructor(props) {
        super(props);
        this.authService = new AuthService();

    }

    render() {
        let doc = this.props.analyzedDocuments[this.props.id];
        let isGuest = this.authService.isGuest();
        return (
            <Grid className="prototype" fluid>
                <NavMenu
                    id={this.props.id}
                    reportId={this.props.reportId}
                    highlightCount={doc ? doc.highlights.length : 0}
                    missingCount={doc ? doc.missingHighlights.length : 0}
                />
                <Topbar
                    currentDocId={this.props.id}
                    currentDocFilename={doc ? doc.fileName : ""}
                    highlightCount={doc ? doc.highlights.length : 0}
                    missingCount={doc ? doc.missingHighlights.length : 0}
                />
                <div className="content-container">
                    {isGuest && <TrialBanner />}
                    <div className={`content${isGuest ? " has-banner" : ""}`}>
                        <ErrorBoundary>
                            {React.cloneElement(this.props.children, { match: this.props.match })}
                        </ErrorBoundary>
                    </div>
                </div>
            </Grid>
        );
    }
}

export default connect(
    state => {
        const { contractReviewer, analysis } = state;
        return { ...contractReviewer, reportId: analysis.id };
    },
    dispatch => bindActionCreators(actions, dispatch)
)(Layout);



// WEBPACK FOOTER //
// ./src/components/Home/Layout.js